import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/huss.webp';
import screenshot_target from '../../../images/letterfunnel/sanderjellema.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Sander Jellema"
      firstname="Sander"
      companyname="Huss"
      competition="Topicus en Infi"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/sanderjellema.js